import {CommandManager} from "../libs/CommandManager";
import {Asset} from "../entities/Asset";
import {CommandBase} from "./CommandBase";
import { ApplicationSetting } from "../entities/ApplicationSetting";
import { ApplicationSettingService } from "../services/ApplicationSettingService";

export class CommandSetThresholdCtrl extends CommandBase{
    thresholdType:string;
    selectedItems:any[];
    levelQuantifier: string;
    defaultLevel: number;
    commandEnabled:boolean = false;
    levelAmount: number = 0;
    temperatureFormat: string = "beep2";
    levelDuration:number = 20;
    static $inject = ['CommandManager'];
    constructor(commandManager: CommandManager) {
        super(commandManager);
    }
    getCommandText(asset:Asset):string{
        return asset.vTagID + ":" + this.thresholdType + ":" + this.levelAmount + ":" + this.levelDuration;
    }
    getCommandType():string{
        return "Set Threshold";
    }
}


export class CommandSetThresholdDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdsetthreshold.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "=",
        thresholdType : "@thresholdType",
        levelQuantifier: "@levelQuantifier",
        defaultLevel: "@defaultLevel"
    };
    constructor() {
    }
    controller = CommandSetThresholdCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.selectedItems.length, (newVal:any)=> {
            controller.selectedItems = scope.selectedItems;
        });
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
        controller.thresholdType = scope.thresholdType;
        controller.defaultLevel = scope.defaultLevel;
        controller.levelQuantifier = scope.levelQuantifier;
        controller.levelAmount = parseFloat(scope.defaultLevel);
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandSetThresholdDirective();
        }
        directive.$inject = [];
        return directive;
    }
}
